<template>
    <footer class="page__footer">
        <div class="footer">
            <div class="footer-content">
                <div class="footer-content__inner">
                    <div class="footer-content__column">
                        <p class="h4">
                            Kontakt
                        </p>
                        <p>
                            Für alle Fragen rund um unsere Aktion wenden Sie sich bitte an <a href="mailto:redaktion@velbert-zeigt-herz.de">redaktion@velbert-zeigt-herz.de</a>. <br><br>Spendencodes können Sie <router-link :to="{name: 'RequestCode'}">hier</router-link> anfordern.
                        </p>
                    </div>
                    <div class="footer-content__column">
                        <p class="h4">
                            Impressum & Co
                        </p>
                        <ul>
                            <li>
                                <router-link :to="{name: 'FAQ'}">
                                    FAQ
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'Imprint'}">
                                    Impressum
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'DataProtection'}">
                                    Datenschutzerklärung
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'AccessibilityStatement'}">
                                    Barrierefreiheitserklärung 
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'ParticipationTerms'}">
                                    Teilnahmebedingungen
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="footer-content__column">
                        <p class="h4">
                            Und sonst...
                        </p>
                        <ul>
                            <li>
                                <a href="https://www.stadtwerke-velbert.de/unternehmen/ueber-uns" target="_blank">
                                    Über die Stadtwerke Velbert
                                </a>
                            </li>
                            <li>
                                <a href="https://www.stadtwerke-velbert.de/presse" target="_blank">
                                    Pressekontakt
                                </a>
                            </li>
                            <li>
                                <a href="https://www.stadtwerke-velbert.de/unternehmen/engagement" target="_blank">
                                    Sponsoringanfragen
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'PageFooter'
}
</script>



// WEBPACK FOOTER //
// src/components/PageFooter.vue